import { setFeatureFlagOverrides } from '@mangovoice/core'

// Dev keys are forced on locally before they exist in PostHog. Set
// VITE_FF_OVERRIDES to a comma-separated list of keys in the (gitignored) root
// .env, e.g. VITE_FF_OVERRIDES=release-notifications-ui. The DEV read
// dead-code-eliminates out of prod builds.
export const applyFeatureFlagOverrides = () => {
  const devFlagOverrides = import.meta.env.DEV
    ? String(import.meta.env.VITE_FF_OVERRIDES ?? '')
        .split(',')
        .map((key) => key.trim())
        .filter(Boolean)
    : []

  setFeatureFlagOverrides(devFlagOverrides)
}

export async function enableMocking(): Promise<void> {
  if (
    import.meta.env.VITE_USE_MSW !== 'true' &&
    import.meta.env.VITE_MOCK_QUEUE_METRICS !== 'true'
  ) {
    return
  }
  const { worker } = await import('./mocks/browser')
  await worker.start({
    onUnhandledFrame: 'bypass',
  })
  console.log('[MSW] Mock service worker started')
}

export const renderOnce = (render: (root: HTMLElement) => void) => {
  const root = document.getElementById('root')
  if (root && !root.dataset.reactMounted) {
    root.dataset.reactMounted = 'true'
    enableMocking()
      .catch((err) => {
        console.error('[MSW] Failed to start:', err)
      })
      .then(() => render(root))
  }
}
